import axios from 'axios'

export const getReviewSurveySubjectFacilities = async (params) => {
  const client = axios.create()
  const response = await client.get('/api/nursing_facilities/review_survey_subjects/', { params })
  const data = response.data
  return data
}
